// src/components/Logo.js
// One place that decides which TroveHub logo to show.
//
//   trovehub-logo.svg       → navy text, for LIGHT backgrounds
//   trovehub-logo-dark.svg  → white text, for DARK backgrounds
//
// variant="auto"    (default) follows the site theme (light/dark toggle + device setting)
// variant="onLight" always the light-background logo (e.g. a white admin card)
// variant="onDark"  always the dark-background logo  (e.g. the always-dark footer)
import React from "react";
import { useTheme } from "../context/ThemeContext";
import logoForLight from "../assets/trovehub-logo.svg";
import logoForDark from "../assets/trovehub-logo-dark.svg";

export default function Logo({ variant = "auto", alt = "TroveHub", ...imgProps }) {
  const theme = useTheme(); // null if used outside <ThemeProvider>
  const useDarkLogo =
    variant === "onDark" || (variant === "auto" && Boolean(theme?.dark));

  return <img src={useDarkLogo ? logoForDark : logoForLight} alt={alt} {...imgProps} />;
}
